module.exports = __webpack_public_path__ + "media/images/mailer-man-interviewing-9dfa22720afa2eb3c3360bd5d82f4b78.png";